/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import Standalone500 from 'base/components/standalone/500';

export const DynamicStandalone500 = Standalone500;
export type DynamicStandalone500Props = PropsFromComponent<typeof Standalone500>;

export const DynamicStandalone500With = (extras: DynamicStandaloneExtras): typeof Standalone500 => {
    return function DynamicStandalone500(props) {
        const theme = extras.theme.useTheme(extras.theme.key || '500');
        return <Standalone500 {...mergeProps({ options: { theme } }, props)} />;
    }
}